<template>
    <exportTemplate ref="exportTemplate" :formModel="formModel" :table-data="tableList" :summary-data="tableSummaryData" :table-total="paginationTotal" :table-load="tableLoading" @set-custom-columns="setCustomColumns" @close-custom-columns="closeCustomColumns" @pagination-change="paginationChange" @form-submit="formSubmit" @form-reset="formReset" @sort="sortChange" @table-export="tableExport">
        <template #form>
            <el-form-item label="日期范围" prop="billDate.selected">
                <date-picker style="width: 100%;" v-model="formModel.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></date-picker>
            </el-form-item>
            <el-form-item label="库房" prop="warehouseID.selected">
                <select-multiple :select-data="formModel.warehouseID"></select-multiple>
            </el-form-item>
            <el-form-item label="商品" prop="product.selected">
                <el-select class="select_multiple" style="width: 100%;" ref="productSelectRef"
                    v-model="formModel.product.selected" value-key="value" multiple clearable placeholder="请选择商品名称"
                    @focus="productInputFocus" @change="productChange">
                    <el-option v-for="item in formModel.product.list" :key="item.value" :label="item.text"
                        :value="item"></el-option>
                </el-select>
            </el-form-item>
        </template>
        <template>
            <el-table-column label="库房" prop="warehouseName" width="120" sortable="custom" fixed>
                <template slot-scope="scope">
                    <span>{{ scope.row.warehouseName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="员工" prop="salesmanName" width="120" fixed></el-table-column>
            <el-table-column label="商品" prop="itemName" sortable="custom" width="140" fixed>
                <template slot-scope="scope">
                    <span>{{ scope.row.itemName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="规格" prop="itemSpec" width="120" v-if="customColumnList['itemSpec']"></el-table-column>
            <el-table-column label="条码" prop="barcodeStr" width="120" v-if="customColumnList['barcodeStr']"></el-table-column>
            <el-table-column label="调入数量" prop="inQryStr" width="110" sortable="custom" v-if="customColumnList['inQryStr']"></el-table-column>
            <el-table-column label="调入小单位数量" prop="inQry" width="130" sortable="custom" v-if="customColumnList['inQry']"></el-table-column>
            <el-table-column label="调出数量" prop="outQryStr" width="110" sortable="custom" v-if="customColumnList['outQryStr']"></el-table-column>
            <el-table-column label="调出小单位数量" prop="outQry" width="130" sortable="custom" v-if="customColumnList['outQry']"></el-table-column>
            <el-table-column label="净调拨数量" prop="cleanQryStr" width="140" sortable="custom" v-if="customColumnList['cleanQryStr']"></el-table-column>
            <el-table-column label="净调拨小单位数量" prop="cleanQry" width="150" sortable="custom" v-if="customColumnList['cleanQry']"></el-table-column>
            <el-table-column label="调拨价格" prop="salContractPriceStr" width="110" v-if="customColumnList['salContractPriceStr']"></el-table-column>
            <el-table-column label="调拨小单位价格" prop="invContractPriceStr" width="110" v-if="customColumnList['invContractPriceStr']"></el-table-column>
            <el-table-column label="金额" prop="contractPriceTotalAmt" width="120" sortable="custom" v-if="customColumnList['contractPriceTotalAmt']"></el-table-column>
            <el-table-column label="成本价" prop="salPriceStr" width="110" v-if="customColumnList['salPriceStr']"></el-table-column>
            <el-table-column label="成本价小单位" prop="invPriceStr" width="110" v-if="customColumnList['invPriceStr']"></el-table-column>
            <el-table-column label="成本总额" prop="totalAmt" width="150" sortable="custom" v-if="customColumnList['totalAmt']"></el-table-column>
            <el-table-column label="毛利" prop="profit" width="110" sortable="custom" v-if="customColumnList['profit']"></el-table-column>
            <el-table-column label="毛利率" prop="profitMarginStr" width="110" sortable="custom" v-if="customColumnList['profitMarginStr']"></el-table-column>
        </template>
        <el-dialog title="选择商品" :visible.sync="selectProductVisible" width="1080px" append-to-body
            :close-on-click-modal="false" custom-class="product-dialog">
            <selectProduct v-if="selectProductVisible" @get-product-data="getProductData"
                :default-checked-keys="formModel.product.list"></selectProduct>
        </el-dialog>
    </exportTemplate>
</template>
  
<script>
import exportTemplate from '@/components/common/exportTemplate.vue'
import datePicker from '@/components/common/datePicker.vue'
import selectProduct from '@/components/common/selectProduct.vue'
import { pickerOptions, getNowFormatDate, getAddDate, getQueryItem, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
    name: 'mainAccount',
    components: {
        exportTemplate,
        datePicker,
        selectProduct
    },
    data() {
        return {
            pickerOptions,
            params: {
                page: 1,
                size: 10,
                beginDate: getAddDate(-3),
                endDate: getNowFormatDate()
            },
            formModel: {
                billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
                warehouseID: { submitName: 'warehouseID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll:false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择库房', request: { url: '/Account/wareHouseDefine/selectWarehouseForVue.html', type: 'post', params: {page: 1, size: 5, isHeteroValence: 'Y'}, text: '', value: '' }},
                product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } }
            },
            paginationTotal: 0,
            tableList: [],
            tableLoading: false,
            tableSummaryData: {},
            dialogCustomerVisible: false,
            customColumnsList: [
                {
                    "label": "规格",
                    "prop": "itemSpec",
                },
                {
                    "label": "条码",
                    "prop": "barcodeStr",
                },
                {
                    "label": "调入数量",
                    "prop": "inQryStr",
                },
                {
                    "label": "调入小单位数量",
                    "prop": "inQry",
                },
                {
                    "label": "调出数量",
                    "prop": "outQryStr",
                },
                {
                    "label": "调出小单位数量",
                    "prop": "outQry",
                },
                {
                    "label": "净调拨数量",
                    "prop": "cleanQryStr",
                },
                {
                    "label": "净调拨小单位数量",
                    "prop": "cleanQry",
                },
                {
                    "label": "调拨价格",
                    "prop": "salContractPriceStr",
                },
                {
                    "label": "调拨小单位价格",
                    "prop": "invContractPriceStr",
                },
                {
                    "label": "金额",
                    "prop": "contractPriceTotalAmt",
                },
                {
                    "label": "成本价",
                    "prop": "salPriceStr",
                },
                {
                    "label": "成本价小单位",
                    "prop": "invPriceStr",
                },
                {
                    "label": "成本总额",
                    "prop": "totalAmt",
                },
                {
                    "label": "毛利",
                    "prop": "profit",
                },
                {
                    "label": "毛利率",
                    "prop": "profitMarginStr",
                }
            ],
            customColumn: [],
            selectProductVisible: false
        }
    },
    created() {
        this.getCustomColumnsList()
        this.getTableList()
    },
    computed: {
        customColumnList() {
            let tempItem = {}
            this.customColumn.forEach(i => {
                tempItem[i.prop] = (i.isShow == 'Y')
            })
            return tempItem
        }
    },
    methods: {
        setCustomColumns(el) {
            let tempArr = [...this.customColumn]
            el.loading = false
            el.setCustomcolumns(tempArr)
        },
        closeCustomColumns(el) {
            el.$nextTick(async () => {
                let { customColumns } = el
                const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
                    funcCode: 239,
                    customSetInfo: JSON.stringify(customColumns)
                }))

                if (res.code != 'success') return this.$message.error(res.message)
                this.$message.success(res.message)
            })
        },
        async getCustomColumnsList() {
            const { data: res } = await this.$http.post(
                "Account/dataSearchVue/selectColumnByFuncCode.html",
                this.Qs.stringify({ funcCode: 239 })
            );
            if (res.code != "success") return this.$confirm(res.message, "提示", {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "error",
            });
            let result = JSON.parse(res.result);
            let arr = [];
            this.customColumnsList.forEach((item) => {
                result.forEach(($item) => {
                    if (item.prop == $item.prop) {
                        arr.push({
                            id: $item.id,
                            label: item.label,
                            prop: item.prop,
                            isShow: $item.isShow,
                        });
                    }
                });
            });
            this.customColumn = [...arr]
        },
        paginationChange({page, size, isGetTable = true}) {
            this.params.page = page
            this.params.size = size
            if (isGetTable) {
                this.getTableList()
            }
        },
        productChange(val) {
            this.formModel.product.list = val
        },
        formSubmit() {
            console.log(getQueryItem(this.formModel))
            this.params = { ...this.params, ...getQueryItem(this.formModel) }
            this.getTableList()
        },
        formReset() {
            this.params['sortField'] = ''
            this.params['softBy'] = ''
            this.params.page = 1
        },
        async getTableList() {
            this.tableLoading = true
            this.tableData = []
            console.log(this.params)
            const { data: res } = await this.$post(
                "/erpnew/account/c/reada46ceb/contract/contractPriceSelect.html",
                this.params
            )
            this.tableLoading = false
            if (res.code != '0') return this.$message.error(res.message)
            if(res.data != null) {
                let { list, sum, totalSum } = res.data
                this.paginationTotal = totalSum
                this.tableSummaryData = sum
                this.tableList = list
            }else {
                this.paginationTotal = 0
                this.tableSummaryData = {}
                this.tableList = []
            }
        },
        sortChange({ sortField, sortBy }) {
            this.params['sortBy'] = sortBy
            if(sortField == 'warehouseName'){
                sortField = 'warehouseID'
            }else if(sortField == 'itemName'){
                sortField = 'itemID'
            }else if(sortField == 'inQryStr'){
                sortField = 'inQry'
            }else if(sortField == 'outQryStr'){
                sortField = 'outQry'
            }else if(sortField == 'cleanQryStr'){
                sortField = 'cleanQry'
            }else if(sortField == 'profitMarginStr'){
                sortField = 'profitMargin'
            }
            this.params['sortField'] = sortField
            this.params.page = 1
            this.getTableList()
        },
        tableExport(tabColumn) {
            // console.log(tabColumn)
            exportExcelCommonForVue(this.params, tabColumn, '/erpnew/account/c/reada46ceb/contract/contractExcelReport.html')
        },
        productInputFocus() {
            this.$refs['productSelectRef'].blur()
            this.selectProductVisible = true
        },
        getProductData(data) {
            this.selectProductVisible = false
            this.formModel.product.selected = data
            this.formModel.product.list = data
        }
    }
}
</script>
  
<style lang="less" scoped>
::v-deep .el-dialog__header {
    padding-left: 20px;
}
</style>